import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

export const submitDrugCsvUploadReportFilterData = async (data = array()) => {
  try {
    const response = await POST(REPORT.DRUG_CSV_ACTIVITY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
